document.addEventListener('DOMContentLoaded', () => {
    const loggedIn = localStorage.getItem('loggedIn');
    if(!loggedIn) {
      const cookies = document.cookie.split('; ');
      const tokenCookieString = cookies.find(a => a.includes('jwt='));
      const token = tokenCookieString ? tokenCookieString.split('=').at(-1) : '';
      if (token) {
        verifyToken = `https://ams.chessclub.com/api/user/profile`;
        fetch(verifyToken, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }).then(response => 
          response.json()
        )
        .then(response => {
          if(!response.error) {
            const url = `https://store.xecurify.com/moas/broker/login/jwt/callback/24069/ICCJWT/${token}?relay=https://store.xecurify.com/moas/broker/login/shopify/shop.chessclub.com/account`;
            localStorage.setItem("loggedIn", true);
            location.href = url;
          }
        })
        .catch(err => console.log(err));
      }
    }
});